import { useTranslations } from 'next-intl';
import { memo } from 'react';
import {
  HoverCard,
  HoverCardArrow,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from '@/app/components/ui/hover-card';

export const ThinkingContent = memo(({ thinking }: { thinking: string }) => {
  const t = useTranslations();
  return (
    <HoverCard openDelay={100} closeDelay={100}>
      <HoverCardTrigger asChild={true}>
        <div className="inline-flex w-fit rounded-8 bg-system-white08 px-2 py-1 text-system-white64 text-xs leading-4">
          {t('claw.chat.thinking.thinkingProcess')}
        </div>
      </HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent side="right" align="start" className="max-w-[520px] bg-system-bg02 p-3 text-xs">
          <div className="max-h-60 overflow-auto whitespace-pre-wrap break-words text-system-white64 leading-5">
            {thinking}
          </div>
          <HoverCardArrow />
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
});

ThinkingContent.displayName = 'ThinkingContent';
